var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIconOutForDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 23.611 24",
    width: 23.611,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Out For Delivery",
    id: "Out_For_Delivery",
    transform: "translate(-17000 4804)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    id: "Back",
    transform: "translate(17000 -4804)",
    width: 23.612
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "scooter_8981448(1)",
    id: "scooter_8981448_1_",
    transform: "translate(17000 -4804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.806,19.122a14.66,14.66,0,0,0-2.066-7.5L19.892,10.2H21.3V5.563h-8.71V8H14V6.971h1.542a2.3,2.3,0,0,0-.186.91v9.826a4.255,4.255,0,0,0-1.025,2.134h-.894l-3.41-6.379H1.773v7.786h.884a3.456,3.456,0,0,0,6.767,0h5.732a3.456,3.456,0,0,0,6.767,0h.884ZM6.04,22.592a2.051,2.051,0,0,1-1.923-1.344H7.963A2.052,2.052,0,0,1,6.04,22.592ZM3.268,19.841a2.86,2.86,0,0,1,5.544,0ZM6.04,16.277a4.25,4.25,0,0,0-2.86,1.1V14.87h6l2.658,4.971h-1.59A4.274,4.274,0,0,0,6.04,16.277Zm13.491-3.936a13.252,13.252,0,0,1,1.736,4.925,4.26,4.26,0,0,0-4.5-.6V10.012a2.3,2.3,0,0,0,.91.186h.581Zm-.992,5.343a2.865,2.865,0,0,1,2.772,2.156H15.766A2.865,2.865,0,0,1,18.538,17.685ZM17.672,6.971h2.221V8.79H17.672a.91.91,0,1,1,0-1.82Zm.866,15.622a2.052,2.052,0,0,1-1.923-1.344h3.847A2.052,2.052,0,0,1,18.538,22.592Z",
    "data-name": "Path 8347",
    fill: "#ffff",
    id: "Path_8347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04,7.008A2.162,2.162,0,1,0,3.878,4.846,2.164,2.164,0,0,0,6.04,7.008Zm0-2.916a.754.754,0,1,1-.754.754A.755.755,0,0,1,6.04,4.091Z",
    "data-name": "Path 8348",
    fill: "#ffff",
    id: "Path_8348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.041,11.619S8.8,9.059,9.627,8.1a4.928,4.928,0,0,0,1.259-3.258,4.846,4.846,0,0,0-9.692-.039A5.031,5.031,0,0,0,2.438,8.086C3.187,8.982,6.041,11.619,6.041,11.619ZM3.616,2.4A3.442,3.442,0,0,1,9.478,4.846a3.566,3.566,0,0,1-.914,2.335C8.01,7.82,6.736,9.038,6.039,9.7c-.714-.67-2.026-1.921-2.521-2.513A3.684,3.684,0,0,1,2.6,4.818,3.417,3.417,0,0,1,3.616,2.4Z",
    "data-name": "Path 8349",
    fill: "#ffff",
    id: "Path_8349"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconOutForDelivery);
export default __webpack_public_path__ + "static/media/status_icon_out_for_delivery.25d6ecf1c21d335daeeca3c289e7e6af.svg";
export { ForwardRef as ReactComponent };